import AirPlay from '@mui/icons-material/Airplay';
import MeetingRoom from '@mui/icons-material/MeetingRoom';
import NoMeetingRoom from '@mui/icons-material/NoMeetingRoom';
import PlayIcon from '@mui/icons-material/PlayCircleOutline';
import SnoozeIcon from '@mui/icons-material/Snooze';
import StopIcon from '@mui/icons-material/Stop';
import { Tooltip, Typography } from '@mui/material';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';

import '../../css/botao.css';
import '../../css/cabecalho.css';
import Configuracao from '../../util/Configuracao';
import ReactComponent from '../ReactComponent';
import ModalConfirmacao from './ModalConfirmacao';

class ControleDeSessao extends ReactComponent {
    pendencias = undefined;
    abrirConfirmacaoFecharSessao = false;
    abrirConfirmacaoFecharPauta = false;
    abrirConfirmacaoIniciarSessao = false;
    sessaoEscolhida = '';

    constructor(props) {
        super(props);

        makeObservable(this, {
            validarFecharPauta: true,
            setStatus: true,
            recuperarPendenciasApreciacoesEncaminhamentoMovimentos: true,
            verificaDataSessao: true,
            handleClickMeetingRoom: true,
            tooltipAguardandoSessao: true,
            handleClickAguardandoSessao: true,
            handleClickSessaoIniciadaOuEncerrada: true,
            handleClickSessaoFechada: true,
            render: true,
            renderConfirmacaoIniciarSessao: true,
            renderConfirmacaoFecharPauta: true,
            renderConfirmacaoFecharSessao: true,
            renderSessaoAberta: true,
            renderAguardandoSessao: true,
            renderSessaoEmPlenarioVirtual: true,
            renderSessaoIniciada: true,
            renderSessaoFechada: true,

            pendencias: observable,
            abrirConfirmacaoFecharSessao: observable,
            abrirConfirmacaoFecharPauta: observable,
            abrirConfirmacaoIniciarSessao: observable,
            sessaoEscolhida: observable,
            statusDaSessao: computed,
            mudarStatus: action,
            fecharConfirmacao: action,
            fecharSessao: action,
            fecharPauta: action,
            iniciarSessao: action
        });
    }

    get statusDaSessao() {
        return this.sessaoStore?.sessaoSelecionada?.situacao;
    }

    mudarStatus = (novoStatus) => {
        const statusAnterior = this.sessaoStore.sessaoSelecionada.situacao;
        let existeSessaoNoStatusAnterior = false;

        for (const sessaoSimples of this.sessaoStore.sessaoSelecionada.sessoes) {
            const statusAtualSessaoSimples = this.sessaoStore.sessaoSelecionada.situacoes[sessaoSimples.id];
            const quantidadeProcessosSessaoSimples = this.salaSessaoStore.getProcessosSessao(sessaoSimples.id).length;

            // Sessão sem processo não é considerada para situação da sessão conjunta
            if (statusAtualSessaoSimples === statusAnterior && quantidadeProcessosSessaoSimples > 0) {
                existeSessaoNoStatusAnterior = true;
                break;
            }
        }
        if (!existeSessaoNoStatusAnterior) {
            this.sessaoStore.sessaoSelecionada.situacao = novoStatus;
            novoStatus === Configuracao.STATUS_INICIADA && this.observableProps.recarregarListaProcessos();
        }
    };

    validarFecharPauta(sessaoId) {
        const validacao = this.store.validarFecharPauta(sessaoId);

        if (validacao.erro) {
            this.mensagemStore.abrirMensagemAlerta(validacao.mensagem);
            return false;
        }

        return true;
    }

    fecharConfirmacao = () => {
        this.abrirConfirmacaoFecharSessao = false;
        this.abrirConfirmacaoFecharPauta = false;
        this.abrirConfirmacaoIniciarSessao = false;
    };

    fecharSessao = async () => {
        await this.sessaoService.alterarSituacaoSessao(this.sessaoEscolhida.id, 'ENCERRADA');
        await this.sessaoService.alterarSituacaoSessao(this.sessaoEscolhida.id, 'FECHADA');
        this.sessaoStore.sessaoSelecionada.situacoes[this.sessaoEscolhida.id] = Configuracao.STATUS_FECHADA; // novo status
        this.mensagemStore.abrirMensagemSucesso('Sessão fechada.');
        this.sessaoEscolhida = '';
        this.abrirConfirmacaoFecharSessao = false;
        this.mudarStatus(Configuracao.STATUS_FECHADA);
    };

    fecharPauta = async () => {
        await this.sessaoService.alterarSituacaoSessao(
            this.sessaoEscolhida.id,
            Configuracao.STATUS_AGUARDANDO_SESSAO_JULGAMENTO
        );
        await this.sessaoService.alterarSituacaoSessao(this.sessaoEscolhida.id, Configuracao.STATUS_INICIADA);
        await this.sessaoService.liberarVotosSessao(this.sessaoEscolhida.id);
        this.sessaoStore.sessaoSelecionada.situacoes[this.sessaoEscolhida.id] = Configuracao.STATUS_INICIADA; // novo status
        this.mensagemStore.abrirMensagemSucesso('Pauta fechada e Sessão iniciada.');
        this.sessaoEscolhida = '';
        this.abrirConfirmacaoFecharPauta = false;
        this.mudarStatus(Configuracao.STATUS_INICIADA);
    };

    iniciarSessao = async () => {
        await this.sessaoService.alterarSituacaoSessao(this.sessaoEscolhida.id, Configuracao.STATUS_INICIADA); // novo status
        await this.sessaoService.liberarVotosSessao(this.sessaoEscolhida.id);
        this.sessaoStore.sessaoSelecionada.situacoes[this.sessaoEscolhida.id] = Configuracao.STATUS_INICIADA;
        this.mensagemStore.abrirMensagemSucesso('Sessão iniciada.');
        this.sessaoEscolhida = '';
        this.abrirConfirmacaoIniciarSessao = false;
        this.mudarStatus(Configuracao.STATUS_INICIADA);
    };

    // Altera os status de todas as sessoes simples que estejam no statusAtual da sessao composta.
    setStatus = async (novoStatus) => {
        const statusAtual = this.statusDaSessao;

        for (const sessaoSimples of this.sessaoStore.sessaoSelecionada.sessoes) {
            const statusAtualSessaoSimples = this.sessaoStore.sessaoSelecionada.situacoes[sessaoSimples.id];
            const quantidadeProcessosSessaoSimples = this.salaSessaoStore.getProcessosSessao(sessaoSimples.id).length;

            if (statusAtual === statusAtualSessaoSimples && quantidadeProcessosSessaoSimples > 0) {
                if (novoStatus === Configuracao.STATUS_INICIADA) {
                    if (statusAtual === Configuracao.STATUS_ABERTA) {
                        if (this.validarFecharPauta(sessaoSimples.id)) {
                            runInAction(() => {
                                this.sessaoEscolhida = sessaoSimples;
                                this.abrirConfirmacaoFecharPauta = true;
                            });
                        }
                    } else {
                        runInAction(() => {
                            this.sessaoEscolhida = sessaoSimples;
                            this.abrirConfirmacaoIniciarSessao = true;
                        });
                    }
                } else {
                    const pendencias = await this.recuperarPendenciasApreciacoesEncaminhamentoMovimentos(
                        sessaoSimples.id
                    );

                    const possuiPendencias = pendencias.length > 0;

                    if (possuiPendencias) {
                        const DESCRICAO_PENDENCIAS = {
                            PROCESSO_PENDENTE_APRECIACAO: 'Não apreciado',
                            AUSENCIA_ENCAMINHAMENTO_MOVIMENTO_ORIGEM: 'Movimento não encaminhado para o PJe'
                        };

                        // Agrupa as pendências por processo
                        const pendenciasPorProcesso = new Map();

                        for (const { numeroProcesso, pendencia } of pendencias) {
                            const chave = numeroProcesso;
                            const descricoes = pendenciasPorProcesso.get(chave) ?? [];
                            descricoes.push(DESCRICAO_PENDENCIAS[pendencia] ?? pendencia);
                            pendenciasPorProcesso.set(chave, descricoes);
                        }

                        const INDENTACAO = '\u{A0}'.repeat(4);

                        const detalhes = [...pendenciasPorProcesso]
                            .map(([numero, descricoes]) => {
                                const linhasPendencias = descricoes.map((d) => INDENTACAO + '– ' + d).join('\n');
                                return `• Processo ${numero}:\n${linhasPendencias}`;
                            })
                            .join('\n');

                        this.mensagemStore.abrirMensagemAlerta(
                            `Não foi possível fechar a sessão ${sessaoSimples.id}, pois existem processos com pendências de apreciação e/ou de encaminhamento de movimentos para o PJe:\n\n${detalhes}`
                        );
                    } else {
                        if (this.store.processosPendentes.length > 0) {
                            this.mensagemStore.abrirMensagemAlerta(
                                'Não foi posível fechar a sessão ' +
                                    sessaoSimples.id +
                                    ' pois ainda existem processos não apreciados.'
                            );
                        } else {
                            runInAction(() => {
                                this.abrirConfirmacaoFecharSessao = true;
                                this.sessaoEscolhida = sessaoSimples;
                            });
                        }
                    }
                }
            }
        }
        this.mudarStatus(novoStatus);
    };

    async recuperarPendenciasApreciacoesEncaminhamentoMovimentos() {
        const PENDENCIAS_RELEVANTES = new Set([
            'PROCESSO_PENDENTE_APRECIACAO',
            'AUSENCIA_ENCAMINHAMENTO_MOVIMENTO_ORIGEM'
        ]);

        const sessoesPendencias = await this.salaSessaoStore.recuperarPendenciasSessao();

        return (sessoesPendencias ?? []).flatMap((sessao) =>
            (sessao.pendenciasProcessos ?? []).flatMap((registro) => {
                const numeroProcesso = registro.numeroProcesso;

                return (registro.pendencias ?? [])
                    .filter((pendencia) => PENDENCIAS_RELEVANTES.has(pendencia))
                    .map((pendencia) => ({
                        sessao,
                        numeroProcesso,
                        pendencia
                    }));
            })
        );
    }

    verificaDataSessao() {
        const dataInicioSessao = moment(
            this.sessaoStore.sessaoSelecionada.prazos.dataInicioSessaoPresencial,
            'DD-MM-YYYY-HH-mm-ss'
        ).format('L');
        return this.isComponenteHabilitado('ValidacaoDatasSessao') ? dataInicioSessao === moment().format('L') : true;
    }

    handleClickMeetingRoom = () => {
        this.setStatus(Configuracao.STATUS_INICIADA);
    };

    tooltipAguardandoSessao = () => {
        return (
            'Aguardando sessão de julgamento. ' +
            (this.verificaDataSessao()
                ? 'Clique para iniciar a sessão.'
                : 'Sessão só pode ser iniciada na data de realização.')
        );
    };

    handleClickAguardandoSessao = () => {
        this.verificaDataSessao()
            ? this.setStatus(Configuracao.STATUS_INICIADA)
            : this.mensagemStore.abrirMensagemAlerta('Sessão só pode ser iniciada na data de realização.');
    };

    handleClickSessaoIniciadaOuEncerrada = () => {
        this.setStatus(Configuracao.STATUS_FECHADA);
    };

    handleClickSessaoFechada = () => {
        this.mensagemStore.abrirMensagemInfo('Sessão já fechada.');
    };

    render() {
        if (!this.sessaoStore?.sessaoSelecionada || !this.store?.existeSessaoPJe) {
            return null;
        }

        return (
            <div
                className="corBotaoAmarelo"
                style={{ color: 'white' }}
            >
                {this.renderSessaoAberta()}
                {this.renderAguardandoSessao()}
                {this.renderSessaoEmPlenarioVirtual()}
                {this.renderSessaoIniciada()}
                {this.renderSessaoFechada()}
                {this.renderConfirmacaoFecharSessao()}
                {this.renderConfirmacaoFecharPauta()}
                {this.renderConfirmacaoIniciarSessao()}
            </div>
        );
    }

    renderConfirmacaoIniciarSessao() {
        return (
            <ModalConfirmacao
                callbackCancelar={this.fecharConfirmacao}
                callbackConfirmar={this.iniciarSessao}
                open={this.abrirConfirmacaoIniciarSessao}
                titulo={'Iniciar sessão'}
            >
                <Typography display={'inline'}>Esta operação registrará a data e hora do início da sessão </Typography>
                <Typography
                    display={'inline'}
                    fontWeight={'bold'}
                >
                    {this.sessaoEscolhida.id + '. '}
                </Typography>
                <Typography display={'inline'}>Deseja continuar?</Typography>
            </ModalConfirmacao>
        );
    }

    renderConfirmacaoFecharPauta() {
        return (
            <ModalConfirmacao
                callbackCancelar={this.fecharConfirmacao}
                callbackConfirmar={this.fecharPauta}
                open={this.abrirConfirmacaoFecharPauta}
                titulo={'Fechar Pauta'}
            >
                <Typography display={'inline'}>Deseja fechar a pauta </Typography>
                <Typography
                    display={'inline'}
                    fontWeight={'bold'}
                >
                    {this.sessaoEscolhida.id}
                </Typography>
                <Typography display={'inline'}>?</Typography>
            </ModalConfirmacao>
        );
    }

    renderConfirmacaoFecharSessao() {
        return (
            <ModalConfirmacao
                callbackCancelar={this.fecharConfirmacao}
                callbackConfirmar={this.fecharSessao}
                open={this.abrirConfirmacaoFecharSessao}
                titulo={'Fechar sessão'}
            >
                <Typography display={'inline'}>Esta operação registrará o fechamento da sessão </Typography>
                <Typography
                    display={'inline'}
                    fontWeight={'bold'}
                >
                    {this.sessaoEscolhida.id + '. '}
                </Typography>
                <Typography display={'inline'}>
                    Não será permitido apregoar e alterar resultados da sessão que foram enviados para o PJe.{' '}
                </Typography>
                <Typography display={'inline'}>Deseja continuar?</Typography>
            </ModalConfirmacao>
        );
    }

    renderSessaoAberta() {
        return (
            (this.statusDaSessao === Configuracao.STATUS_ABERTA ||
                this.statusDaSessao === Configuracao.STATUS_NAO_GERENCIADA_ABERTA) && (
                <Tooltip
                    placement="top-start"
                    title={'Pauta ABERTA. Fechar a pauta?'}
                >
                    <MeetingRoom
                        onClick={this.handleClickMeetingRoom}
                        style={{ verticalAlign: 'middle', margin: '8px', cursor: 'pointer' }}
                    />
                </Tooltip>
            )
        );
    }

    renderAguardandoSessao() {
        return (
            this.statusDaSessao === Configuracao.STATUS_AGUARDANDO_SESSAO_JULGAMENTO && (
                <Tooltip
                    placement="top-start"
                    title={this.tooltipAguardandoSessao()}
                >
                    <SnoozeIcon
                        onClick={this.handleClickAguardandoSessao}
                        style={{ verticalAlign: 'middle', margin: '8px', cursor: 'pointer' }}
                    />
                </Tooltip>
            )
        );
    }

    renderSessaoEmPlenarioVirtual() {
        return (
            this.statusDaSessao === Configuracao.STATUS_PLENARIO_VIRTUAL && (
                <Tooltip
                    placement="top-start"
                    title={'Sessão em Plenário Virtual'}
                >
                    <AirPlay
                        onClick={() =>
                            this.mensagemStore.abrirMensagemInfo(
                                'Sessão em Plenário Virtual. A situação será alterada automaticamente ao final do período de votação virtual.'
                            )
                        }
                        style={{ verticalAlign: 'middle', margin: '8px', cursor: 'pointer' }}
                    />
                </Tooltip>
            )
        );
    }

    renderSessaoIniciada() {
        return (
            (this.statusDaSessao === Configuracao.STATUS_INICIADA ||
                this.statusDaSessao === Configuracao.STATUS_ENCERRADA) && (
                <Tooltip
                    placement="top-start"
                    title={'Sessão ' + this.statusDaSessao + '. Clique para Fechar Sessão'}
                >
                    {this.statusDaSessao === Configuracao.STATUS_ENCERRADA ? (
                        <StopIcon
                            onClick={this.handleClickSessaoIniciadaOuEncerrada}
                            style={{ verticalAlign: 'middle', margin: '8px', cursor: 'pointer' }}
                        />
                    ) : (
                        <PlayIcon
                            onClick={this.handleClickSessaoIniciadaOuEncerrada}
                            style={{ verticalAlign: 'middle', margin: '8px', cursor: 'pointer' }}
                        />
                    )}
                </Tooltip>
            )
        );
    }

    renderSessaoFechada() {
        return (
            (this.statusDaSessao === Configuracao.STATUS_FECHADA ||
                this.statusDaSessao === Configuracao.STATUS_NAO_GERENCIADA_FECHADA) && (
                <Tooltip
                    placement="top-start"
                    title={'Sessão FECHADA'}
                >
                    <NoMeetingRoom
                        onClick={this.handleClickSessaoFechada}
                        style={{ verticalAlign: 'middle', margin: '8px', cursor: 'pointer' }}
                    />
                </Tooltip>
            )
        );
    }
}

export default inject('stores')(observer(ControleDeSessao));
